import { Typography } from "@thingsw/pitta-design-system";
import { LightColors } from "@thingsw/pitta-modules";
import React from "react";

interface SurveyContentProps {
  title: string;
  description: string;
  content: React.ReactNode;
}

const SurveyContent = ({ title, description, content }: SurveyContentProps) => {
  return (
    <>
      <div
        style={{
          paddingLeft: 6,
          display: "flex",
          flexDirection: "column",
          gap: 16,
          paddingBottom: 80,
        }}
      >
        <Typography variant="H3">{title}</Typography>
        <Typography htmlColor={LightColors.primary["2"]} variant="BodyBold">
          {description}
        </Typography>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
          marginBottom: 84,
        }}
      >
        {content}
      </div>
    </>
  );
};

export default SurveyContent;
